import { render, staticRenderFns } from "./GeneralImagesEdit.vue?vue&type=template&id=5b9d9085&scoped=true&"
import script from "./GeneralImagesEdit.vue?vue&type=script&lang=js&"
export * from "./GeneralImagesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d9085",
  null
  
)

export default component.exports